import { useEffect, useState } from 'react'

// Global state for footer detection - simple state variable approach
let hasFooter = false
let setHasFooter: ((value: boolean) => void) | null = null

export const useFooterState = () => {
  const [footerState, setFooterState] = useState(hasFooter)

  useEffect(() => {
    // Register this component as the state manager
    setHasFooter = setFooterState
    // Set initial state in case it changed while no component was listening
    setFooterState(hasFooter)

    return () => {
      setHasFooter = null
    }
  }, [])

  return { hasFooter: footerState }
}

export const useFooterRegistration = () => {
  useEffect(() => {
    hasFooter = true
    setHasFooter?.(true)

    return () => {
      hasFooter = false
      setHasFooter?.(false)
    }
  }, [])
}
